export default "__VITE_ASSET__f2c1fbeb__"